import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { ReCollectionTab } from "./ReCollectionTab";

const TYPES = ["apartment", "villa", "townhouse", "penthouse", "duplex", "studio", "plot", "office"];
const COMMUNITIES = [
  "Dubai Marina", "Downtown Dubai", "Palm Jumeirah", "Business Bay", "Dubai Hills Estate",
  "Arabian Ranches", "Jumeirah Village Circle", "Jumeirah Beach Residence", "Emaar Beachfront",
  "DAMAC Hills", "Emirates Hills", "Dubai Creek Harbour",
];

const aed = (n) => "AED " + Number(n || 0).toLocaleString();

export const ListingsTab = () => {
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    api.get("/admin/realestate/agents").then((r) => setAgents(r.data)).catch(() => {});
  }, []);

  const cfg = useMemo(() => ({
    heading: "Listings",
    singular: "Listing",
    image: (i) => i.cover_image || (i.photos || [])[0],
    title: (i) => `${i.reference || ""} · ${i.title}`,
    subtitle: (i) =>
      `${i.community || "—"} · ${aed(i.price)}${i.purpose === "rent" ? "/yr" : ""} · ${i.bedrooms ?? 0} bed · ${i.completion_status || "ready"}`,
    badge: (i) => (
      <span
        className={`shrink-0 rounded-full px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.12em] ${
          i.status === "draft" ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"
        }`}
      >
        {i.status === "draft" ? "Draft" : "Live"}
      </span>
    ),
    beforeSave: (p) => {
      if (!p.cover_image && Array.isArray(p.photos) && p.photos.length) p.cover_image = p.photos[0];
    },
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "reference", label: "Reference (empty = auto DOC-XXXX)", type: "text" },
      { name: "type", label: "Property Type", type: "select", options: TYPES },
      { name: "purpose", label: "Purpose", type: "select", options: [{ value: "sale", label: "For Sale" }, { value: "rent", label: "For Rent" }] },
      { name: "price", label: "Price (AED)", type: "number" },
      { name: "price_period", label: "Rent Period (yearly/monthly — rentals only)", type: "text" },
      { name: "area_sqft", label: "Area (sq ft)", type: "number" },
      { name: "bedrooms", label: "Bedrooms", type: "number" },
      { name: "bathrooms", label: "Bathrooms", type: "number" },
      { name: "community", label: "Community / Area", type: "select", options: COMMUNITIES },
      { name: "developer", label: "Developer", type: "text" },
      { name: "completion_status", label: "Completion", type: "select", options: [{ value: "ready", label: "Ready" }, { value: "off-plan", label: "Off-Plan" }] },
      { name: "handover_date", label: "Handover (off-plan, e.g. Q4 2026)", type: "text" },
      { name: "furnishing", label: "Furnishing", type: "select", options: ["Unfurnished", "Semi-Furnished", "Furnished"] },
      { name: "permit_number", label: "DLD Permit / RERA No.", type: "text" },
      { name: "agent_id", label: "Assigned Agent", type: "select", options: [{ value: "", label: "— Unassigned —" }, ...agents.map((a) => ({ value: a.id, label: a.name }))] },
      { name: "description", label: "Description", type: "textarea" },
      { name: "amenities", label: "Amenities (comma separated)", type: "list" },
      { name: "lat", label: "Map Latitude", type: "number" },
      { name: "lng", label: "Map Longitude", type: "number" },
      { name: "cover_image", label: "Cover Image", type: "image" },
      { name: "photos", label: "Gallery Photos", type: "images" },
      { name: "featured", label: "Featured on homepage", type: "boolean" },
      { name: "status", label: "Status", type: "select", options: [{ value: "published", label: "Published (Live)" }, { value: "draft", label: "Draft (Hidden)" }] },
    ],
  }), [agents]);

  return <ReCollectionTab endpoint="realestate/listings" cfg={cfg} />;
};
